"use client"

import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface MyReply {
  id: string
  message: string
  admin_reply: string
  replied_at: string | null
}

export function SupportReplyModal() {
  const [reply, setReply] = useState<MyReply | null>(null)
  const [open, setOpen] = useState(false)
  const [acking, setAcking] = useState(false)

  useEffect(() => {
    let cancelled = false
    fetch("/api/support/my-reply")
      .then((res) => (res.ok ? res.json() : { reply: null }))
      .then((data) => {
        if (cancelled) return
        if (data?.reply?.admin_reply) {
          setReply(data.reply as MyReply)
          setOpen(true)
        }
      })
      .catch(() => {
        // best-effort : ne bloque jamais le rendu de l'app
      })
    return () => {
      cancelled = true
    }
  }, [])

  const acknowledge = async () => {
    if (!reply || acking) return
    setAcking(true)
    try {
      await fetch(`/api/support/my-reply/${reply.id}/read`, { method: "POST" })
    } catch {
      // même en cas d'échec réseau, on ferme : pas de boucle bloquante
    } finally {
      setOpen(false)
      setReply(null)
    }
  }

  if (!reply) return null

  const origin = reply.message?.trim()
  const originPreview =
    origin && origin.length > 160 ? `${origin.slice(0, 160)}…` : origin

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        // Acquittement explicite via le bouton uniquement : on ne ferme pas
        // par clic extérieur / Échap pour être sûr que l'élève voie la réponse.
        if (!next) return
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="text-[#7c3aed]">
            Réponse de l’équipe KIDSHAKER
          </DialogTitle>
          <DialogDescription>
            Tu as reçu une réponse à ton message.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-xl border border-[#7c3aed]/20 bg-[#7c3aed]/5 p-4">
          <p className="whitespace-pre-wrap text-sm leading-relaxed text-zinc-800">
            {reply.admin_reply}
          </p>
        </div>

        {originPreview && (
          <p className="text-xs text-zinc-500">
            En réponse à : « {originPreview} »
          </p>
        )}

        <Button
          type="button"
          onClick={acknowledge}
          disabled={acking}
          className="w-full rounded-xl bg-[#7c3aed] hover:bg-[#6d28d9]"
          autoFocus
        >
          OK, compris
        </Button>
      </DialogContent>
    </Dialog>
  )
}
